import { Skeleton } from "@bowfast/ui/components/skeleton";

const ROW_KEYS = ["row-a", "row-b", "row-c", "row-d", "row-e"] as const;

interface ListSkeletonProps {
  /** Number of skeleton rows (max 5). Defaults to 5. */
  rows?: 1 | 2 | 3 | 4 | 5;
  /** Tailwind height class for each row. Defaults to "h-[72px]". */
  rowHeight?: string;
}

export function ListSkeleton({ rows = 5, rowHeight = "h-[72px]" }: ListSkeletonProps) {
  return (
    <div className="space-y-3">
      {ROW_KEYS.slice(0, rows).map((key) => (
        <Skeleton key={key} className={`${rowHeight} w-full rounded-xl`} />
      ))}
    </div>
  );
}
